module.exports = __webpack_public_path__ + "static/media/logo.5715d853.svg";